import { render, staticRenderFns } from "./BtnImprimirXml.vue?vue&type=template&id=f4783386&"
import script from "./BtnImprimirXml.vue?vue&type=script&lang=js&"
export * from "./BtnImprimirXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports